module.exports = __webpack_public_path__ + "img/ABC-LOGO.e6b222a5.svg";